
export function allbox_click(event) {
	$w("#gallery1").show();
$w("#gallery2").hide();
	$w("#gallery3").hide();
$w("#anchor1").scrollTo();

}